module.exports = __webpack_public_path__ + "static/make-video-slide4@2x-572ea66bbecd5de0c63e5648fd773c27.png";